import { SemanticContext, Spider, isSemanticEvent } from '@cp/shared/tracking';
import { IConfigManager } from '@cp/shared/config';
import { IEvent } from '@cp/shared/cqrs';
import merge from 'lodash/merge';
import { gtmFactory } from './integrations/gtm.factory';
import { yandexMetrikaFactory } from './integrations/yandexMetrika.factory';
import { dwhFactory } from './integrations/dwh.factory';
import { IntegrationFactory } from './integrations/factory';
import { createDatalayer } from './integrations/dataLayer';

export class SpiderService {
  #logger = console;
  public readonly spider: Spider;
  #configManager: IConfigManager;
  #ctx: SemanticContext;

  constructor(configManager: IConfigManager) {
    this.#configManager = configManager;
    this.#ctx = Spider.createContext({
      version: this.#configManager.get('BUILD_ID', ''),
    });
    this.spider = new Spider(3, this.#ctx);
    this.initIntegrations();
  }

  private initIntegrations() {
    const global = window;
    SpiderService.getIntegrationsFactories(this.#configManager).map((createIntegration) => {
      createIntegration(this.#configManager, global, this.#ctx)
        .then((integration) => {
          this.#logger.info('Loaded integration', integration.displayName);
          this.spider.addIntegration(integration);
        })
        .catch((result) => {
          this.#logger.warn('Can not load integration', result);
        });
    });
  }

  onMessageReceived(e: IEvent) {
    if (isSemanticEvent(e)) {
      this.spider.trackEvent(e);
    }
  }

  updateContext(ctx: Partial<SemanticContext>) {
    this.spider.updateContext(merge(this.#ctx, ctx));
  }

  static getIntegrationsFactories(configManager: IConfigManager): IntegrationFactory[] {
    const names: IntegrationFactory[] = [];
    // Yandex Metrika
    if (configManager.get('YANDEX_METRIKA_COUNTER_ID')) {
      names.push(yandexMetrikaFactory);
    }
    // GTM
    if (configManager.get('GTM_ID')) {
      names.push(gtmFactory);
      names.push(createDatalayer);
    }

    // DWH
    if (configManager.get('DWH_URL')) {
      names.push(dwhFactory);
    }

    return names;
  }
}
